import styled from '@emotion/styled'
import { tablet, mobile } from './/media'
import { mq } from './/helpers'

export const defs = {
  maxWidth: 1440,
  mobileMaxWidth: 560,
  pad: {
    base: 128,
    tablet: 40,
    mobile: 16
  },
  maxWidthWithPad: 1440 + 256
}

export const components = {
  FullWidth: styled.div`
    width: 100vw;
    margin-left: calc((100vw - 100%) / 2 * -1);
  `,
  Container: pad => {
    if (!pad) {
      pad = {
        base: { top: 0, bottom: 0 },
        tablet: { top: 0, bottom: 0 },
        mobile: { top: 0, bottom: 0 }
      }
    }
    return styled.div`
      box-sizing: content-box;
      padding: ${pad.base.top}px ${defs.pad.base}px ${pad.base.bottom}px;
      max-width: ${defs.maxWidth}px;
      margin: 0 auto;
      @media ${mq.and(tablet)} {
        padding: ${pad.tablet.top}px ${defs.pad.tablet}px ${pad.tablet.bottom}px;
      }
      @media ${mq.and(mobile)} {
        max-width: ${defs.mobileMaxWidth}px;
        padding: ${pad.mobile.top}px ${defs.pad.mobile}px ${pad.mobile.bottom}px;
      }
    `
  }
}

export default {
  defs, components
}
